import { useEffect, useState } from "react";
import Lenis from "lenis";
import { AnimatePresence } from "framer-motion";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Impressum from "./pages/Impressum";
import Datenschutz from "./pages/Datenschutz";
import Kontakt from "./pages/Kontakt";
import KontaktSection from "./components/KontaktSection";
import Preloader from "./components/Preloader";
import Header from "./components/Header";
import Hero from "./components/Hero";
import MarqueeStrip from "./components/MarqueeStrip";
import Angebot from "./components/Angebot";
import Lounge from "./components/Lounge";
import Anlaesse from "./components/Anlaesse";
import Preise from "./components/Preise";
import Standort from "./components/Standort";
import FinalCTA from "./components/FinalCTA";
import Footer from "./components/Footer";

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  useEffect(() => {
    const t = setTimeout(() => setLoading(false), 2300);
    return () => clearTimeout(t);
  }, []);

  return (
    <BrowserRouter>
      <div className="min-h-screen bg-[#120d0b] text-[#f4ecdd]">
        <AnimatePresence>{loading && <Preloader />}</AnimatePresence>
        <div className="grain" aria-hidden="true" />
        <Routes>
          <Route
            path="/"
            element={
              <>
                <Header />
                <main>
                  <Hero ready={!loading} />
                  <MarqueeStrip />
                  <Angebot />
                  <Lounge />
                  <Anlaesse />
                  <Preise />
                  <Standort />
                  <KontaktSection />
                  <FinalCTA />
                </main>
                <Footer />
              </>
            }
          />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/datenschutz" element={<Datenschutz />} />
          <Route path="/kontakt" element={<Kontakt />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
